import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { AppConfigHttpService } from '@services/http/app-config.http.service';
import { catchError, lastValueFrom, of, OperatorFunction } from 'rxjs';

const logAndIgnore = <T>(message: string): OperatorFunction<T, T | null> =>
  catchError((error) => {
    console.error(message, error);
    return of(null);
  });

export const loadAppInitializationData = async (
  appConfigService: AppConfigHttpService,
  authenticationService: AuthenticationService,
): Promise<void> => {
  await Promise.all([
    lastValueFrom(appConfigService.getAppConfig().pipe(logAndIgnore('Error during configuration loading:'))),
    lastValueFrom(authenticationService.initAuth().pipe(logAndIgnore('Error during authentication initialization:'))),
  ]);
};
